export var UserSettingsKeys;
(function (UserSettingsKeys) {
    UserSettingsKeys["LANGUAGE"] = "language";
    UserSettingsKeys["DATETIME"] = "datetime";
    UserSettingsKeys["FORMAT"] = "format";
    UserSettingsKeys["DATEFORMAT"] = "dateFormat";
    UserSettingsKeys["TIMEZONE"] = "timezone";
    UserSettingsKeys["CLOCKFORMAT"] = "clockFormat";
    UserSettingsKeys["TZ_IN_FORMAT"] = "tzInFormat";
    UserSettingsKeys["EVENTS"] = "events";
    UserSettingsKeys["UNITS"] = "units";
    UserSettingsKeys["NOTIFICATIONS"] = "notifications";
    UserSettingsKeys["RULES"] = "rules";
    UserSettingsKeys["MODE"] = "mode";
    UserSettingsKeys["PAUSE"] = "pause";
    UserSettingsKeys["UNTIL"] = "until";
    UserSettingsKeys["DISMISSED"] = "msgDismissedAt";
    UserSettingsKeys["PREFERENCES"] = "preferences";
    UserSettingsKeys["FAVORITE_GROUP_ID"] = "favoriteGroupId";
    UserSettingsKeys["FAVORITE_DEPARTMENT_ID"] = "favoriteDepartmentId";
    UserSettingsKeys["ANNOTATE_LOGGER_STATE_CHANGE"] = "annotateLoggerStateChange";
    UserSettingsKeys["MEASUREMENT_SORT"] = "measurementSort";
    UserSettingsKeys["EVENTS_REFRESH"] = "eventsRefresh";
    UserSettingsKeys["STATUS_PAGE_REFRESH"] = "statusPageRefreshEnabled";
    UserSettingsKeys["DASHBOARD_LAYOUT"] = "dashboardLayout";
    UserSettingsKeys["ENABLED"] = "enabled";
    UserSettingsKeys["INTERVAL"] = "interval";
    UserSettingsKeys["REPORTS"] = "reports";
    UserSettingsKeys["RECORDS"] = "records";
    UserSettingsKeys["CONFIGURATION"] = "configuration";
    UserSettingsKeys["FILTER_BY_BOUNDARY"] = "filterByBoundary";
    UserSettingsKeys["PROFILE"] = "profile";
    UserSettingsKeys["CUSTOM"] = "customSettings";
    UserSettingsKeys["CHARTHEIGHTS"] = "chartHeights";
    UserSettingsKeys["MAIN"] = "main";
    UserSettingsKeys["GAS"] = "gas";
    UserSettingsKeys["WIND"] = "wind";
    UserSettingsKeys["WATERLEVEL"] = "waterlevel";
    UserSettingsKeys["NOISE"] = "noise";
    UserSettingsKeys["SCHEDULE_MODE"] = "scheduleMode";
    UserSettingsKeys["USERRATING"] = "userRating";
    UserSettingsKeys["ISSUBMITTED"] = "isSubmitted";
    UserSettingsKeys["FIRST_LOGIN_TIMESTAMP"] = "firstLoginTimestamp";
    UserSettingsKeys["LASTSHOWNTIMESTAMP"] = "lastShownTimestamp";
    UserSettingsKeys["FLOORPLAN_SETTINGS"] = "floorPlanSettings";
    UserSettingsKeys["DISPLAY_MODE"] = "displayMode";
    UserSettingsKeys["EVENTTYPE"] = "eventType";
    UserSettingsKeys["HARDWARE"] = "selectedHardware";
    UserSettingsKeys["PINNED_MENU_ITEMS"] = "pinnedMenuItems";
})(UserSettingsKeys || (UserSettingsKeys = {}));
